import React, { Fragment, useEffect, useState, useCallback } from "react"
import { useParams } from "react-router-dom"
import _ from "lodash"
import { Asterisk, Globe, User, CircleUser } from "lucide-react"
import { useAppCtx, appStore } from "lib/state";
import { queryTools, cn } from "lib/utils";
import { GridTableButton, Tabset, TagsManager } from "lib/components"
import { Forms } from "lib/components/forms"

export default function Design(){

  const { desid } = useParams()
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()

  const { data:_Design } = queryTools.resource.parseQueryForApi("design.findById", { _id: desid }, { enabled: !!desid })
  const saveMethod = queryTools.resource.save(["design.all"])

  const [ designFormData, setDesignFormData ] = useState<any>({..._Design})


  const handleInputChange = (e:any) => setDesignFormData({ ...designFormData, [e.target.name]: e.target.value })


  const saveDesign = () => {
    saveMethod.mutate({ resource: "design", data: _Design._id } )
  }

  // useEffect(() => {

  // },[])

  if( !_Design ) return <></>
  return(
    <div className="w-full h-full border border-solid border-slate-700 p-[2px]">
      <div className="w-full h-6 pl-4 pr-2 h-8 flex items-center bg-slate-700 text-white text-sm uppercase">Edit Design: { _Design?.name }</div>
      <div className="w-full flex flex-col px-4 py-2">

        <Tabset tabs={["basics", "styles"]}>
          
          <div id="basics">
            <div className="w-full flex gap-3">
              <Forms.Form className="w-7/12 flex flex-col">
                <Forms.FieldGroup label="Design Name" className="w-full">
                  <Forms.InputField 
                    type="text" 
                    name="name" 
                    value={designFormData.name} 
                    onChange={handleInputChange}  
                  />
                </Forms.FieldGroup>

                <Forms.FieldGroup label="Description" className="w-full">
                  <Forms.Textarea 
                    name="description" 
                    value={designFormData.description} 
                    onChange={handleInputChange}  
                  />
                </Forms.FieldGroup>

                <Forms.FieldGroup label="Fun Fact" className="w-full">
                  <Forms.Textarea 
                    name="funfact" 
                    value={designFormData.funfact}
                    className="h-36" 
                    onChange={handleInputChange}  
                  />
                </Forms.FieldGroup>
              </Forms.Form>
            </div>

            <div className="w-full flex justify-center items-center mt-3">
              <button 
                className="w-full px-3 py-1 text-sm border border-solid border-teal-700 bg-teal-800 hover:bg-teal-900" 
                onClick={saveDesign}
              >
                Save
              </button>
            </div>
          </div>

        </Tabset>

      </div>
    </div>
  )
}